// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media, { setBreakPoints } from 'css-in-js-media';
import { Row, Col } from '../../../_atoms/grid';
import Element from '../../../element';

setBreakPoints({ desktop: 1024, largeDesktop: 1710, tablet: 840 });

// SOLUTIONS MEGA MENU

export const SolutionsMegaMenuContainer = styled.div`
  height: 400px;
  width: 900px;
  padding-left: 14px;
  padding-right: 14px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: -40px;

  ${media('<largeDesktop')} {
    margin: 0 auto;
  }
  ${media('<desktop')} {
    width: auto;
    margin: 0 auto;
  }

  ${media('<tablet')} {
    height: auto;
    margin: 24px auto;
  }
`;

// PRODUCTS MEGA MENU

export const SmallIconContainer = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;

  ${media('<tablet')} {
    margin-bottom: 20px;
  }
`;

export const SmallIconImg = styled.div`
  margin-top: 40px;
  width: 30px;

  ${media('<desktop')} {
    margin-right: 5px;
    margin-top: -5px;
  }
`;

export const SmallIconHeadlineContainer = styled.div`
  display: flex;
  margin-top: 10px;

  > h1.is-6 {
    color: #031b4e !important;
    margin-bottom: 19px !important;
  }

  ${media('<desktop')} {
    margin-bottom: 5px;
  }
`;

export const SmallIconLink = styled(Element)`
  color: hsl(221, 19%, 44%);
  font-size: 14px !important;
  font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif' !important;
  margin-bottom: 12px;
  padding-bottom: 0 !important;

  &:hover {
    color: #0069ff;
  }
`;

export const MegaMenuLargeIconLinkContainer = styled(Element)`
  margin-top: 6px;
  display: flex;
  position: relative;

  .chevron {
    position: absolute;
    display: none;
  }
  &:hover {
    color: #0069ff;
    .chevron {
      display: block;
      right: 21px;
      top: 28px;
    }
  }

  a {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 13px 10px;
    border-radius: 5px;
  }
  ${media('<desktop')} {
    margin-left: 0px;
  }
`;

export const LargeIconLinksStyledContainer = styled.div`
  width: 229px;
  height: 328px;
`;

// COMMUNITY MEGA MENU

export const MegaMenuListLink = styled(Element)`
  color: hsl(221, 19%, 44%) !important;
  font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif';
  font-size: 14px !important;
  line-height: 1.2;
  padding: 8px 0 8px 50px !important;

  &:hover {
    color: #0069ff !important;
  }

  ${media('<desktop')} {
    font-size: 14px !important;
    margin-bottom: 10px;
    margin-left: 15px;
    margin-right: 15px;
    padding: 5px 0 15px 0;
    width: 100%;
  }
`;

export const MegaMenuArticleContainer = styled(Element)`
  display: flex;
  margin: 20px 0 20px 50px !important;
  padding: 0 !important;
  white-space: normal !important;
  cursor: pointer;

  :first-of-type {
    margin-top: 30px !important;
  }

  :hover p {
    color: #0069ff !important;
  }

  img {
    width: 52px !important;
    height: 52px !important;
  }

  ${media('<desktop')} {
    align-items: center;
    display: flex;

    margin-top: 0 !important;

    :first-of-type {
      margin-top: 0 !important;
    }
  }
`;

export const MegaMenuArticleText = styled.p`
  color: #5b6987 !important;
  font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif';
  line-height: 1.5;
  max-width: 300px;
  padding-left: 20px;
  font-size: 14px;

  ${media('<desktop')} {
    font-size: 13px !important;
    line-height: 1.5em !important;
    max-width: 170px;
    padding-left: 15px;
  }
`;

export const MegaMenuArticleImg = styled.img`
  width: 52px !important;
  height: 52px !important;
  border-radius: 10px;

  ${media('<desktop')} {
    min-width: 50px;
    min-height: 50px;
  }
`;

// SOLUTIONS MEGA MENU, PRODUCTS MEGA MENU, & COMMUNITY MEGA MENU

export const MegaMenuColumns = styled(Row)`
  flex-direction: ${props => (props.flexDirection ? props.flexDirection : 'row')};
  padding: ${props => (props.padding ? props.padding : 'auto')};
  flex-wrap: nowrap !important;
  min-height: 460px;

  &.solutions-columns {
    padding: 24px;
  }

  ${media('<desktop')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: none;
    min-height: none;
    border-bottom: none;

    a.nav-item {
      padding: 3px 16px;
      padding: 0 20px 20px 0;
    }
  }
`;

export const MegaMenuBorderRight = styled.div`
  padding: 24px 38px 54px 38px !important;
  width: 305px;

  background: #f1f7ff;
  border-radius: 8px 0px 0px 0px;

  ${media('<desktop')} {
    background: #fff;
    min-width: auto;
    min-height: auto;
  }
`;

export const NavTitle = styled.h1`
  color: #0069ff;
  font-family: 'WorkSans-Bold', 'Helvetica', 'san-serif';
  font-size: 12px !important;
  font-weight: bold;
  letter-spacing: 1px !important;
  margin-bottom: 20px !important;
  margin-top: 40px;
  text-transform: uppercase;

  &.products-title,
  &.solutions-title,
  &.community-title {
    padding: 3px 16px;
  }

  &.products-title,
  &.solutions-title,
  &.community-title {
    margin-left: -5px;
    margin-top: 20px !important;
  }

  &.solutions-title {
    padding-left: 30px !important;
    margin-bottom: 16px !important;
  }

  &.community-get-involved-title,
  &.community-featured-title {
    color: #031b4e;
    padding: 8px 0 8px 50px !important;
  }

  ${media('<desktop')} {
    margin-bottom: 5px;
    margin-top: 0;
    padding-left: 0px !important;
  }

  ${media('<tablet')} {
    margin-bottom: 5px !important;
  }
`;

export const LargeIconLink = styled(Element)`
  display: flex;

  &:hover {
    background: rgba(0, 105, 255, 0.08) !important;

    &:after {
      content: url('../../../../assets/images/chevron-icon.svg');
      display: block;
    }

    h1 {
      color: #0069ff !important;
    }
  }

  div:hover {
    h1,
    span {
      color: #0069ff !important;
    }
  }
`;

export const LargeIconImg = css`
  margin-top: 2px;
  max-height: 52px !important;
  max-width: 52px;
  border-radius: 10px;
`;

export const LargeIconTitle = styled.h1`
  color: #031b4e !important;
  font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif' !important;
  font-size: 15px !important;
  font-weight: bold;
  letter-spacing: 0 !important;
  margin-top: 2px;
  margin-bottom: 8px;

  ${media('<desktop')} {
    font-size: 14px !important;
    margin-left: 5px;
  }
`;

export const LargeIconSubtitle = styled.div`
  color: hsl(221, 19%, 44%) !important;
  font-size: 14px !important;
  font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif' !important;

  ${media('<desktop')} {
    font-size: 12px !important;
    margin-left: 5px;
  }
`;

export const MegaMenuHr = styled.hr`
  background-color: hsl(218, 18%, 91%);
  display: none;
  margin-top: 20px;
  width: 100%;
`;

export const MegaMenuDropdown = styled.div`
  margin-top: -2.8px;
  border-top: 1px solid rgb(229, 232, 237);
  box-shadow: 0 2px 4px rgba(3, 27, 78, 0.1);
  padding-top: 0;
  margin-top: -1px;
  position: absolute;
  top: 65px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #f1f7ff;
  background: white;
  z-index: 4;
  left: 240px;
  border-radius: 6px;

  justify-self: center;
  margin-left: auto;
  margin-right: auto;

  &#communityMegaDropdown {
    padding-bottom: 0px !important;

    .community-featured {
      margin-right: 110px;

      p {
        margin: 0;
      }
    }

    .get-involved {
      margin-right: 22px;
    }
  }

  .get-involved,
  featured {
    color: #031b4e;
    display: flex;
    flex-direction: column;
  }

  ${media('<largeDesktop')} {
    left: 65px;
  }

  ${media('<desktop')} {
    max-width: 80%;
    overflow: hidden;
    margin: 0;
    box-shadow: none;
    display: block;
    position: relative;
    flex-direction: column;
    left: 0;
    margin-bottom: 100px;
    border-bottom: none;
    border-top: none;
  }
`;

export const MegaMenuAllLink = styled.div`
  border-top: 1px solid #f1f7ff;
  height: 40px;
  text-align: center;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  &.solutions-link {
    background: #f1f7ff;
  }
`;

export const MegaMenuAllLinkA = styled(Element)`
  img {
    color: #031b4e !important;
  }
  color: #031b4e;
  font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif' !important;
  font-size: 12px !important;
  text-align: center;
  position: relative;

  .blue {
    display: none;
  }

  .grey {
    right: -16px;
    top: 1px;
  }

  :hover {
    color: hsl(215, 100%, 50%) !important;

    .blue {
      display: block;
      right: -16px;
      top: 1px;
    }

    .grey {
      display: none;
    }
  }
`;

export const MegaMenuArrow = styled.img`
  position: absolute;
  color: hsl(218, 18%, 91%) !important;
  height: 15px !important;
  width: 15px;
`;

export const MegaMenuColumn = styled(Col)`
  margin-right: 28px;
  padding: 0px;
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  flex: ${props => (props.size ? props.size : 'auto')};

  :nth-of-type(3n) {
    z-index: 5;
  }

  :nth-of-type(4n),
  :nth-of-type(5n) {
    margin-top: -180px;
  }

  :nth-of-type(5n) {
    margin-left: -289px;
  }

  @media screen and (max-width: 1120px) {
    flex: 20%;
  }

  ${media('<desktop')} {
    margin-right: 0;

    :nth-of-type(4n),
    :nth-of-type(5n) {
      margin-top: 20px;
    }
  }

  ${media('<desktop')} {
    margin-right: 0;

    :nth-of-type(4n),
    :nth-of-type(5n) {
      margin-left: 0;
    }
  }
`;
